import { Link } from "react-router-dom";
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faXTwitter,
  faInstagram,
  faYoutube,
  faLinkedin,
  faFacebook,
} from "@fortawesome/free-brands-svg-icons";
import ReCAPTCHA from "react-google-recaptcha";

function Contactfile() {
  const [captchaValue, setCaptchaValue] = useState(null);
  const captchaRef = useRef(null);

  const [contactData, setContactData] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
    website: "", // honeypot field
  });

  const [loading, setLoading] = useState(false);

  const handleCaptchaChange = (value) => {
    setCaptchaValue(value);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // 🛑 Honeypot check (bot detection)
    if (formData.website) {
      return;
    }

    // 🛑 CAPTCHA check
    if (!captchaValue) {
      alert("Please complete the CAPTCHA");
      return;
    }

    setLoading(true);

    try {
      await axios.post("https://api.dremerz.net/api/mybankshoppyuserlist", {
        ...formData,
        captcha: captchaValue,
      });

      alert("Form submitted successfully!");

      // ✅ Reset form
      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
        website: "",
      });

      // ✅ Reset captcha
      captchaRef.current.reset();
      setCaptchaValue(null);
    } catch (error) {
      console.error(error);
      alert("There was an error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const getdata = async () => {
    try {
      const response = await axios.get(
        "https://api.dremerz.net/api/mybankshoppycontactuspagesection",
      );
      setContactData(response.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getdata();
  }, []);

  return (
    <>
      <section className="contact-one pt-120 pb-120">
        <div className="container">
          <div className="row">
            <div className="col-lg-4">
              <div className="contact-one__content">
                <div className="block-title">
                  <p className="block-title__tagline">{contactData.input2}</p>
                  <h2 className="block-title__title">{contactData.input3}</h2>
                </div>
                <p className="contact-one__text">{contactData.input4}</p>

                <div className="contact-one__social">
                  <a
                    href="https://x.com/mybankshoppy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faXTwitter} />
                  </a>
                  <a
                    href="https://www.instagram.com/mybankshoppyinsta/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                  <a
                    href="https://www.youtube.com/@MyBankShoppy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faYoutube} />
                  </a>
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faLinkedin} />
                  </a>
                  <a
                    href="https://www.facebook.com/mybankshoppy"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FontAwesomeIcon icon={faFacebook} />
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-8">
              <form onSubmit={handleSubmit} className="form-one">
                <div className="row row-gutter-y-20 row-gutter-x-20">
                  {/* Honeypot (hidden field) */}
                  <input
                    type="text"
                    name="website"
                    style={{ display: "none" }}
                    value={formData.website}
                    onChange={handleChange}
                  />

                  <div className="col-md-6">
                    <input
                      type="text"
                      placeholder="Full name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      type="email"
                      placeholder="Email address"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      type="text"
                      placeholder="Phone number"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-6">
                    <input
                      type="text"
                      placeholder="Subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="col-md-12">
                    <textarea
                      placeholder="Message"
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                  </div>

                  <div className="col-md-12">
                    <ReCAPTCHA
                      ref={captchaRef}
                      sitekey="6LcWh9gsAAAAAIuICXayGySrdI8koALHxGpGIgZR"
                      onChange={handleCaptchaChange}
                    />
                  </div>

                  <div className="col-md-12">
                    <button
                      type="submit"
                      className="thm-btn"
                      disabled={loading || !captchaValue}
                    >
                      {loading ? "Sending..." : "Send a Message"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contactfile;
